var _desc, _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconElectricityGray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "48px",
    height: "48px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "C0A0B8C2-E0BC-4E8E-8725-1D510B96700C_SVG") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M48,24 C48,37.2548348 37.2548348,48 24,48 C10.7451652,48 0,37.2548348 0,24 C0,10.7451652 10.7451652,0 24,0 C37.2548348,0 48,10.7451652 48,24 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Eraklient",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Elekter---Era---Leping---Expanded",
    transform: "translate(-248.000000, -414.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy-3",
    transform: "translate(208.000000, 208.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Kaart-/-Master-Copy-11",
    transform: "translate(24.000000, 190.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(16.000000, 16.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Role-Eraisik_48px"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#E7E7E7",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.7472218,23.0172444 C34.0707932,22.5684027 34.0846487,22.0053496 33.7834428,21.5453135 C33.4822368,21.0852774 32.9130565,20.800175 32.2954941,20.8 L26.5002505,20.8 L26.5002505,8 L14.253069,24.9841778 C13.9292174,25.4328024 13.9152535,25.9958483 14.2165726,26.4557621 C14.5178918,26.915676 15.0873042,27.2004303 15.7047967,27.2 L21.5000403,27.2 L21.5000403,40 L33.7472218,23.0172444 Z",
    id: "Path",
    stroke: "#909090",
    strokeWidth: 1.5,
    mask: "url(#mask-2)"
  })))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconElectricityGray);
export default __webpack_public_path__ + "static/media/Icon_Electricity_Gray.e90ed07422948a281d5501b0d0960812.svg";
export { ForwardRef as ReactComponent };